export const PATH = '/edition/configuration';
